import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import { Accordion } from 'flowbite';

document.addEventListener('DOMContentLoaded', function ()
{

    const navbar = document.getElementById('header');
    const heroSection = document.querySelector('section#hero');

    if (!navbar || !heroSection) return;

    const observer = new IntersectionObserver(
        ([entry]) => {
            if (entry.isIntersecting) {
                // Dentro del hero - restaurar fondo original
                navbar.classList.remove('bg-neutral-900');
                navbar.classList.add('bg-transparent');
            } else {
                // Fuera del hero - cambiar fondo
                navbar.classList.remove('bg-transparent');
                navbar.classList.add('bg-neutral-900');
            }
        },
        {
            root: null,
            threshold: 0,
            rootMargin: "-100px 0px 0px 0px" // Ajusta para activar un poco antes de salir del hero
        }
    );

    observer.observe(heroSection);

    const swiperHero = new Swiper('.swiper-hero', {
        loop: true,
/*        autoplay: true,
        speed: 1500,*/
        pagination: {
            el: ".swiper-pagination-hero",
        },
    });

    const swiperProyectos = new Swiper('.swiper-proyectos', {
        loop: true,
        /*        autoplay: true,
                speed: 1500,*/
        navigation: {
            nextEl: ".swiper-button-next-proyectos",
            prevEl: ".swiper-button-prev-proyectos",
        },
        breakpoints: {
            640: {
                slidesPerView: 1,
                spaceBetween: 20,
            },
            768: {
                slidesPerView: 1,
                spaceBetween: 40,
            },
            1024: {
                slidesPerView: 2.8,
                spaceBetween: 40,
            },
        }
    });

    const swiperRealizados = new Swiper('.swiper-realizados', {
        loop: true,
        /*        autoplay: true,
                speed: 1500,*/
        pagination: {
            el: ".swiper-pagination-realizados",
        },
        breakpoints: {
            640: {
                slidesPerView: 1,
                spaceBetween: 20,
            },
            768: {
                slidesPerView: 1.8,
                spaceBetween: 40,
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 40,
            },
        }
    });


    const accordionElement = document.getElementById('accordion-ventajas');

    const accordionItems = [
        {
            id: 'accordion-ventaja-ubicacion-heading',
            triggerEl: document.querySelector('#accordion-ventaja-ubicacion-heading'),
            targetEl: document.querySelector('#accordion-ventaja-ubicacion-body'),
            active: true
        },
        {
            id: 'accordion-ventaja-calidad-confianza-heading',
            triggerEl: document.querySelector('#accordion-ventaja-calidad-confianza-heading'),
            targetEl: document.querySelector('#accordion-ventaja-calidad-confianza-body'),
            active: false
        },
        {
            id: 'accordion-ventaja-atencion-personalizada-heading',
            triggerEl: document.querySelector('#accordion-ventaja-atencion-personalizada-heading'),
            targetEl: document.querySelector('#accordion-ventaja-atencion-personalizada-body'),
            active: false
        },
        {
            id: 'accordion-ventaja-experiencia-liderazgo-heading',
            triggerEl: document.querySelector('#accordion-ventaja-experiencia-liderazgo-heading'),
            targetEl: document.querySelector('#accordion-ventaja-experiencia-liderazgo-body'),
            active: false
        }
    ];

    const options = {
        alwaysOpen: false,
        activeClasses: 'accordion-active',
        inactiveClasses: 'accordion',
        onOpen: (item) => {

        },
        onClose: (item) => {

        },
        onToggle: (item) => {

        },
    };

    const instanceOptions = {
        id: 'accordion-ventajas',
        override: true
    };

    const accordion = new Accordion(accordionElement, accordionItems, options, instanceOptions);


});
